/**
 * How a worker is employed (core vocabulary, like the tier and the role):
 * full time, part time, PRN (per diem, called on as needed) or agency
 * (contract staff). The facility's scheduling rules keep different caps for
 * each, and every screen that names a worker says which. A record from
 * before the field existed reads as full time.
 */
export type EmploymentType = 'full_time' | 'part_time' | 'prn' | 'agency'

export const EMPLOYMENT_TYPES: readonly EmploymentType[] = ['full_time', 'part_time', 'prn', 'agency']

export const EMPLOYMENT_TYPE_LABELS: Record<EmploymentType, string> = { full_time: 'Full time', part_time: 'Part time', prn: 'PRN', agency: 'Agency' }

/** The short badge beside the role: full time is the norm and not worn; the others are. */
export const EMPLOYMENT_TYPE_BADGE: Record<EmploymentType, string | null> = { full_time: null, part_time: 'PT', prn: 'PRN', agency: 'AGY' }

export function employmentTypeOf(record: { employmentType?: EmploymentType | null }): EmploymentType {
  return record.employmentType ?? 'full_time'
}

/** "Part time", "PRN", "Agency" beside a worker's name; nothing for full time, the norm. */
export function employmentTypeNote(record: { employmentType?: EmploymentType | null }): string | null {
  const type = employmentTypeOf(record)
  return type === 'full_time' ? null : EMPLOYMENT_TYPE_LABELS[type]
}
